var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailLine = function SvgMailLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.4 4.5h16.2a.9.9 0 0 1 .9.9v13.2a.9.9 0 0 1-.9.9H4.4a.9.9 0 0 1-.9-.9V5.4a.9.9 0 0 1 .9-.9m15.3 3.814-7.135 6.39L5.3 8.294V17.7h14.4zM5.76 6.3l6.795 5.996L19.252 6.3z"
  })));
};
export default SvgMailLine;